interface ZeroFeesConfig {
	isActive: boolean;
	pnlModalCardImagePath?: string;
}

type ZeroFeesConfigByMarketIndex = Record<number, ZeroFeesConfig | undefined>;

export const ZERO_FEES_CONFIG_BY_MARKET_INDEX: ZeroFeesConfigByMarketIndex = {
	1: {
		isActive: process.env.NEXT_PUBLIC_ZERO_FEES_IS_ACTIVE_1 === 'true',
		pnlModalCardImagePath: '/assets/images/pnl/pnl-btc-zero.webp',
	},
	2: {
		isActive: process.env.NEXT_PUBLIC_ZERO_FEES_IS_ACTIVE_2 === 'true',
		pnlModalCardImagePath: '/assets/images/pnl/pnl-eth-zero.webp',
	},
};

export const ZERO_FEES_ACTIVE_MARKET_INDEXES = Object.entries(
	ZERO_FEES_CONFIG_BY_MARKET_INDEX
)
	.filter(([_, config]) => config?.isActive)
	.map(([marketIndex]) => Number(marketIndex));
